import { Navigate, Outlet } from 'react-router-dom'
import { PrivateRoutes, PublicRoutes } from '../../models/route'
import { useEffect, useState } from 'react'
import { ususarioStore } from "../../stores/usuarioStore";

type Props = {
	privateValidation: boolean
}

const PrivateValidationFragment = <Outlet />
const PublicValidationFragment = (
	<Navigate replace to={PublicRoutes.LOGIN} />
)

export const AuthGuard = ({ privateValidation }: Props) => {
	const { usuario } = ususarioStore()
	const [username] = useState(usuario?.token ? true : false)

	return username ? (
		privateValidation ? (
			PrivateValidationFragment
		) : (
			PublicValidationFragment
		)
	) : (
		<Navigate replace to={PublicRoutes.LOGIN} />
	)
}

export default AuthGuard
